import {useEffect, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";

import {clientRpRequestMeta} from "../../../client/client_rp_request_meta";
import {IRPStore} from "../../app/rp_reducer";
import {fetchPropertyPlannerEstateDetails} from "../actions/fetch_property_planner_estate_details";

export enum DaylightLevel {
    STANDARD = "standard",
    GOOD = "good",
    VERY_GOOD = "very_good",
    EXCELLENT = "excellent"
}

const minDaylightPercentages = [
    {type: DaylightLevel.EXCELLENT, min: 25.1},
    {type: DaylightLevel.VERY_GOOD, min: 22.1},
    {type: DaylightLevel.GOOD, min: 17.1},
    {type: DaylightLevel.STANDARD, min: 0}
];

export const usePropertyPlannerEstateDetails = () => {
    const plannerEstateDetails = useSelector((state: IRPStore) => state.property.plannerEstateDetails);
    const dispatch = useDispatch();

    const totalStats = useMemo(() => {
        const maxSunlightPercentage = plannerEstateDetails?.rooms
            ? Math.max(...(plannerEstateDetails.rooms.map((room) => room.sunlight_percentage).filter(Boolean) as number[]), 0)
            : 0;

        const daylightLevel = maxSunlightPercentage
            ? minDaylightPercentages.find((record) => {
                  return maxSunlightPercentage >= record.min;
              })?.type
            : null;

        return {
            maxSunlightPercentage,
            daylightLevel
        };
    }, [plannerEstateDetails]);

    useEffect(() => {
        const ctx = {
            meta: clientRpRequestMeta
        };

        dispatch(fetchPropertyPlannerEstateDetails(ctx));
    }, []);

    return {
        plannerEstateDetails,
        totalStats
    };
};
import {useEffect, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";

import {clientRpRequestMeta} from "../../../client/client_rp_request_meta";
import {IRPStore} from "../../app/rp_reducer";
import {fetchPropertyPlannerEstateDetails} from "../actions/fetch_property_planner_estate_details";

export enum DaylightLevel {
    STANDARD = "standard",
    GOOD = "good",
    VERY_GOOD = "very_good",
    EXCELLENT = "excellent"
}

const minDaylightPercentages = [
    {type: DaylightLevel.EXCELLENT, min: 25.1},
    {type: DaylightLevel.VERY_GOOD, min: 22.1},
    {type: DaylightLevel.GOOD, min: 17.1},
    {type: DaylightLevel.STANDARD, min: 0}
];

export const usePropertyPlannerEstateDetails = () => {
    const plannerEstateDetails = useSelector((state: IRPStore) => state.property.plannerEstateDetails);
    const dispatch = useDispatch();

    const totalStats = useMemo(() => {
        const maxSunlightPercentage = plannerEstateDetails?.rooms
            ? Math.max(...(plannerEstateDetails.rooms.map((room) => room.sunlight_percentage).filter(Boolean) as number[]), 0)
            : 0;

        const daylightLevel = maxSunlightPercentage
            ? minDaylightPercentages.find((record) => {
                  return maxSunlightPercentage >= record.min;
              })?.type
            : null;

        return {
            maxSunlightPercentage,
            daylightLevel
        };
    }, [plannerEstateDetails]);

    useEffect(() => {
        const ctx = {
            meta: clientRpRequestMeta
        };

        dispatch(fetchPropertyPlannerEstateDetails(ctx));
    }, []);

    return {
        plannerEstateDetails,
        totalStats
    };
};
